/* eslint-disable react/prop-types */
import React from 'react';

import AmChart from './amchart.jsx';

import 'amcharts3/amcharts/serial';
import reportErrors from 'components/charts/reportErrors.jsx';

let ClusteredBarChart = ({
    data, labelRotation, balloonTexts, gridThickness, containerHeight,
    rotate, bulletBorderThickness, gridAlpha, labelsEnabled,
    tickLength, inside, newCategoryLabel, axisColor, labelsText, customLabelColor,
    titleField = 'name', valueFields, fillColorsField = 'color', verticalAxisTitle = '',
    colors = ['#52b9e9', '#7b8791', '#006fba', '#043673'], titleFontSize, fixedColumnWidth = undefined, fillAlphas, precision = -1,
}) =>
  <AmChart height={containerHeight || containerHeight === 0 ? containerHeight : 300} config={{
    type: 'serial',
    theme: 'light',
    colors: colors,
    zoomOutButtonImage: '',
    dataProvider: data.map(d => Object.assign(d)),
    categoryField: titleField,
    rotate: !!rotate,
    graphs: valueFields.map((field, i) => ({
      balloonText: balloonTexts != null && balloonTexts.length === valueFields.length ? balloonTexts[i] : '[[value]]',
      bulletBorderThickness: bulletBorderThickness != null ? bulletBorderThickness : 0,
      fillAlphas: fillAlphas != null ? fillAlphas : 1,
      fillColorsField: fillColorsField,
      labelText: labelsText != null  && labelsText.length === valueFields.length ? labelsText[i] : '',
      lineAlpha: 0,
      type: 'column',
      valueField: field,
      fixedColumnWidth: fixedColumnWidth,
    })),
    categoryAxis: {
      axisColor: axisColor != null ? axisColor : '#7B8791',
      gridPosition: 'start',
      gridThickness: gridThickness != null ? gridThickness : 1,
      labelFunction: function(label) { return newCategoryLabel != null ? newCategoryLabel : label; },
      labelRotation: labelRotation != null ? labelRotation : 0,
      tickLength: tickLength != null ? tickLength : 5,
      labelColorField: 'labelColor',
      tickPosition: 'middle',
      gridAlpha: 0,
      titleFontSize: titleFontSize != null ? titleFontSize : 13,
    },
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false,
    },
    valueAxes: [
      {
        axisColor: axisColor != null ? axisColor : '#7B8791',
        labelsEnabled: labelsEnabled != null ? labelsEnabled : true,
        gridAlpha: gridAlpha != null ? gridAlpha : 0.18,
        position: 'left',
        title: verticalAxisTitle,
        minimum: 0,
      },
    ],
    startDuration: 0,
    numberFormatter: {
      precision: precision,
      decimalSeparator: '.',
      thousandsSeparator: ',',
    },
  }} />

;

export default reportErrors(ClusteredBarChart);
